module.exports = __webpack_public_path__ + "static/img/ico_band.d86e51c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/ico/ico_band.svg
// module id = axmx
// module chunks = 0